const statusClasses = {
    completed:  'grid__status--completed',
    failed:     'grid__status--failed',
    pending:    'grid__status--pending',
    preparing:  'grid__status--active',
    rendering:  'grid__status--active',
    finalizing: 'grid__status--active',
};

const StatusCell = ({ value }) => {
    const className = statusClasses[value] || 'grid__status--pending';

    return (
        <span className={`grid__status ${className}`}>
            {value}
        </span>
    );
};

export default StatusCell;
